<mat-toolbar *ngIf="!(isHandset$ | async)!.matches">

  <button mat-button type="button" routerLink="">{{title}}</button>

  <span class="spacer"></span>
  <a routerLink="" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }">Home</a>

  <!-- Explore Dropdown -->
  <button mat-button [matMenuTriggerFor]="exploreMenu" class="nav-dropdown-btn">
    <span>Explore</span>
    <mat-icon class="dropdown-icon">expand_more</mat-icon>
  </button>
  <mat-menu #exploreMenu="matMenu" class="custom-nav-menu">
    <a mat-menu-item routerLink="/exhibits">
      <mat-icon>museum</mat-icon>
      <span>Exhibits</span>
    </a>
    <!-- Hidden for now
    <a mat-menu-item routerLink="/tour">
      <mat-icon>navigation</mat-icon>
      <span>Self-Guided Audio Tour</span>
    </a>
    <a mat-menu-item routerLink="/timeline">
      <mat-icon>timeline</mat-icon>
      <span>Historical Timeline</span>
    </a>
    -->
    <a mat-menu-item routerLink="/gallery">
      <mat-icon>collections</mat-icon>
      <span>Photo Gallery</span>
    </a>
    <!-- Hidden for now
    <a mat-menu-item routerLink="/shop">
      <mat-icon>storefront</mat-icon>
      <span>Museum Gift Store</span>
    </a>
    -->
    <a mat-menu-item routerLink="/past-events">
      <mat-icon>history</mat-icon>
      <span>Past Events Archive</span>
    </a>
  </mat-menu>

  <a routerLink="/events" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }">Events</a>
  <a routerLink="/about" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }">About</a>
  <a routerLink="/memberships" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }">Members</a>
  <a routerLink="/donate" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }" class="donate-nav-link">
    <mat-icon class="donate-icon">favorite</mat-icon>
    Donate
  </a>
  <a routerLink="/contact" routerLinkActive="router" [routerLinkActiveOptions]="{ exact: true }">Contact</a>
  <a routerLink="/appointment" class="cta-plan-btn">
    <mat-icon class="cta-icon">calendar_today</mat-icon>
    Plan Visit
  </a>
</mat-toolbar>